import { render, staticRenderFns } from "./RoomTable.vue?vue&type=template&id=0ca55bf9&lang=pug&"
import script from "./RoomTable.vue?vue&type=script&lang=ts&"
export * from "./RoomTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports